import React from 'react';
import { withProviders } from './providers';
import Routing from '../pages';
import Layout from '../widgets/layout/Layout';

function App() {
  return (
    <Layout>
      <Routing />
    </Layout>
  );
}

export default withProviders(App);
